import React from 'react';
import {
  Box,
  Img,
  Heading,
  SimpleGrid,
  Card,
  CardBody,
  VStack,
} from '@chakra-ui/react';
import CountUp from 'react-countup';

interface IFeatureMapProps {}

const FeatureMap: React.FunctionComponent<IFeatureMapProps> = () => (
  <Box
    as="section"
    maxW="1440px"
    w="100%"
    position="relative"
    mx="auto"
    mt={{ xs: '20px', md: '0' }}
    zIndex="-10"
    height="100%"
    mb={{ xs: '80px', sm: '80px', lg: '100px' }}
    px={{ xs: '20px', md: '0px' }}
    overflow={{ xs: 'hidden', md: 'visible' }}
  >
    <Img
      //   display={{ xs: 'none', md: 'block' }}
      alt="world map"
      objectFit="cover"
      src="/png/map.png"
      flexShrink="0"
      zIndex="-10"
      position="absolute"
      top={{ md: '80px', lg: '20px', xl: '180px' }}
      w={{ md: '250%', lg: '100%' }}
      height="100%"
    />
    <Box position="relative">
      <Box
        pt={{ xs: '40px', md: '50px', lg: '50px' }}
        pb={{ xs: '100px', sm: '80px', md: '100px', lg: '88px' }}
        zIndex="10"
      >
        <Heading
          as="h2"
          variant="calendarTitle"
          mb="5rem"
          color="primary.600"
          textAlign="center"
        >
          Indian PE/VC Industry
        </Heading>
        <SimpleGrid
          columns={{ xs: 1, md: 3 }}
          spacing={{ xs: 4, md: 6 }}
          justifyItems="center"
          px={{ xs: '20px', md: '40px' }}
        >
          <Card
            bg="white"
            shadow="lg"
            borderRadius="xl"
            border="1px solid"
            borderColor="gray.100"
            transition="all 0.3s ease"
            _hover={{
              transform: 'translateY(-4px)',
              shadow: 'xl',
              borderColor: 'primary.200',
            }}
            w="100%"
            maxW="300px"
          >
            <CardBody textAlign="center" py={4}>
              <VStack spacing={2}>
                <Heading
                  as="h2"
                  variant="largeInfo"
                  lineHeight={{ xs: '50px', sm: '60px' }}
                  fontSize={{ xs: '32px', md: '48px' }}
                  fontWeight={600}
                >
                  $<CountUp end={450} start={0} duration={10} /> Bn+
                </Heading>
                <Heading
                  as="h3"
                  variant="featureTitle"
                  color="primary.600"
                  textTransform="capitalize"
                  fontSize={'16px'}
                  fontWeight="600"
                >
                  Invested since 2015
                </Heading>
              </VStack>
            </CardBody>
          </Card>

          <Card
            bg="white"
            shadow="lg"
            borderRadius="xl"
            border="1px solid"
            borderColor="gray.100"
            transition="all 0.3s ease"
            _hover={{
              transform: 'translateY(-4px)',
              shadow: 'xl',
              borderColor: 'primary.200',
            }}
            w="100%"
            maxW="300px"
          >
            <CardBody textAlign="center" py={4}>
              <VStack spacing={2}>
                <Heading
                  as="h2"
                  variant="largeInfo"
                  lineHeight={{ xs: '50px', sm: '60px' }}
                  fontSize={{ xs: '32px', md: '48px' }}
                  fontWeight={600}
                >
                  <CountUp end={5800} start={0} duration={10} />+
                </Heading>
                <Heading
                  as="h3"
                  variant="featureTitle"
                  color="primary.600"
                  textTransform="capitalize"
                  fontSize={'16px'}
                  fontWeight="600"
                >
                  Companies funded since 2015
                </Heading>
              </VStack>
            </CardBody>
          </Card>

          <Card
            bg="white"
            shadow="lg"
            borderRadius="xl"
            border="1px solid"
            borderColor="gray.100"
            transition="all 0.3s ease"
            _hover={{
              transform: 'translateY(-4px)',
              shadow: 'xl',
              borderColor: 'primary.200',
            }}
            w="100%"
            maxW="300px"
          >
            <CardBody textAlign="center" py={4}>
              <VStack spacing={2}>
                <Heading
                  as="h2"
                  variant="largeInfo"
                  lineHeight={{ xs: '50px', sm: '60px' }}
                  fontSize={{ xs: '32px', md: '48px' }}
                  fontWeight={600}
                >
                  $<CountUp end={180} start={0} duration={10} /> Bn+
                </Heading>
                <Heading
                  as="h3"
                  variant="featureTitle"
                  color="primary.600"
                  textTransform="capitalize"
                  fontSize={'16px'}
                  fontWeight="600"
                >
                  Exits Recorded Since 2015
                </Heading>
              </VStack>
            </CardBody>
          </Card>
        </SimpleGrid>
      </Box>

      <Box>
        <Heading
          as="h2"
          variant="calendarTitle"
          color="primary.600"
          textAlign="center"
        >
          Total SEBI registered AIFs and IVCA representation
        </Heading>
        <Heading
          as="h3"
          variant="featureTitle"
          color="primary.500"
          textTransform="capitalize"
          fontSize="14px"
          textAlign="center"
          mb="5rem"
        >
          (As of 15th July 2025)
        </Heading>
        <SimpleGrid
          columns={{ xs: 1, sm: 2, md: 4 }}
          spacing={{ xs: 4, md: 6 }}
          justifyItems="center"
          px={{ xs: '20px', md: '40px' }}
        >
          <Card
            bg="white"
            shadow="lg"
            borderRadius="xl"
            border="1px solid"
            borderColor="gray.100"
            transition="all 0.3s ease"
            _hover={{
              transform: 'translateY(-4px)',
              shadow: 'xl',
              borderColor: 'primary.200',
            }}
            w="100%"
            maxW="280px"
          >
            <CardBody
              textAlign="center"
              py={4}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <VStack spacing={2}>
                <Heading
                  as="h2"
                  variant="largeInfo"
                  lineHeight={{ xs: '45px', sm: '55px' }}
                  fontSize={{ xs: '32px', md: '48px' }}
                  fontWeight={600}
                >
                  <CountUp end={784} start={0} duration={10} />
                </Heading>
                <Heading
                  as="h3"
                  variant="featureTitle"
                  color="primary.600"
                  textTransform="capitalize"
                  fontSize={'16px'}
                  fontWeight="600"
                >
                  IVCA Member's AIFs
                </Heading>
              </VStack>
            </CardBody>
          </Card>

          <Card
            bg="white"
            shadow="lg"
            borderRadius="xl"
            border="1px solid"
            borderColor="gray.100"
            transition="all 0.3s ease"
            _hover={{
              transform: 'translateY(-4px)',
              shadow: 'xl',
              borderColor: 'primary.200',
            }}
            w="100%"
            maxW="280px"
          >
            <CardBody
              textAlign="center"
              py={4}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <VStack spacing={2}>
                <Heading
                  as="h2"
                  variant="largeInfo"
                  lineHeight={{ xs: '45px', sm: '55px' }}
                  fontSize={{ xs: '32px', md: '48px' }}
                  fontWeight={600}
                >
                  <CountUp end={1600} start={0} duration={10} />+
                </Heading>
                <Heading
                  as="h3"
                  variant="featureTitle"
                  color="primary.600"
                  textTransform="capitalize"
                  fontSize={'16px'}
                  fontWeight="600"
                >
                  Total SEBI Registered AIFs
                </Heading>
              </VStack>
            </CardBody>
          </Card>

          <Card
            bg="white"
            shadow="lg"
            borderRadius="xl"
            border="1px solid"
            borderColor="gray.100"
            transition="all 0.3s ease"
            _hover={{
              transform: 'translateY(-4px)',
              shadow: 'xl',
              borderColor: 'primary.200',
            }}
            w="100%"
            maxW="280px"
          >
            <CardBody
              textAlign="center"
              py={4}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <VStack spacing={2}>
                <Heading
                  as="h2"
                  variant="largeInfo"
                  lineHeight={{ xs: '45px', sm: '55px' }}
                  fontSize={{ xs: '32px', md: '48px' }}
                  fontWeight={600}
                >
                  <CountUp end={49} start={0} duration={10} />%
                </Heading>
                <Heading
                  as="h3"
                  variant="featureTitle"
                  color="primary.600"
                  textTransform="capitalize"
                  fontSize={'16px'}
                  fontWeight="600"
                >
                  AIFs Represented by IVCA
                </Heading>
              </VStack>
            </CardBody>
          </Card>

          <Card
            bg="white"
            shadow="lg"
            borderRadius="xl"
            border="1px solid"
            borderColor="gray.100"
            transition="all 0.3s ease"
            _hover={{
              transform: 'translateY(-4px)',
              shadow: 'xl',
              borderColor: 'primary.200',
            }}
            w="100%"
            maxW="280px"
          >
            <CardBody
              textAlign="center"
              py={4}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <VStack spacing={2}>
                <Heading
                  as="h2"
                  variant="largeInfo"
                  lineHeight={{ xs: '45px', sm: '55px' }}
                  fontSize={{ xs: '32px', md: '48px' }}
                  fontWeight={600}
                >
                  <CountUp end={78} start={0} duration={10} />%
                </Heading>
                <Heading
                  as="h3"
                  variant="featureTitle"
                  color="primary.600"
                  textTransform="capitalize"
                  fontSize={'16px'}
                  fontWeight="600"
                >
                  IVCA Member Fund Managers have AIFs registered
                </Heading>
              </VStack>
            </CardBody>
          </Card>
        </SimpleGrid>
      </Box>
    </Box>
  </Box>
);

export default FeatureMap;
